import { upperFirst } from 'lodash-es';
import { ref } from 'vue';
import type { FormSchema } from '@mts/components/Form';
import type { EmitType, Recordable } from '@mts-fe/types';
import { type BaseFormProps, createApi } from '..';

export const FORM_EMIT_EVENTS = [
  'advanced-change',
  'reset',
  'submit',
  'focus-change',
  'field-value-change',
  'change',
];
/** 透传表单事件 */
export const useFormEvents = (emit: EmitType, callback?: EmitType) =>
  FORM_EMIT_EVENTS.reduce(
    (acc, evt) =>
      Object.assign(acc, {
        [`on${upperFirst(evt)}`]: (...args) => (callback?.(evt, ...args), emit(evt, ...args)),
      }),
    {} as Recordable<Function>,
  );

export type FormFieldChanged = (key: string, value: any, schema: FormSchema) => void;
export type FormChanged = (formModel: Recordable, schema: FormSchema) => void;

/** 基于表单配置执行接口调用 */
export const useFormApi = (
  formProps: BaseFormProps,
  record: Recordable,
  callback: (res: Recordable) => void,
) => {
  const loading = ref(false);
  const { api, modelId } = formProps;
  if (!api) return { loading };

  const params = { modelId };
  const data = { id: record.id };
  Object.assign(params, formProps.flatParam ? data : { data });

  const fetch = (params: Recordable) => {
    loading.value = true;
    createApi(api)({ ...params, modelId })
      .then(callback)
      .finally(() => (loading.value = false));
  };
  formProps['immediate'] !== false && fetch(params);

  return { fetch, loading };
};
